/**
 * @generated SignedSource<<04d6064c13acaa148ca850d3ba343d38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueItemBlockedBy$data = {
  readonly issueDependenciesSummary: {
    readonly blockedBy: number;
  };
  readonly " $fragmentType": "IssueItemBlockedBy";
};
export type IssueItemBlockedBy$key = {
  readonly " $data"?: IssueItemBlockedBy$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueItemBlockedBy">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueItemBlockedBy",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueDependenciesSummary",
      "kind": "LinkedField",
      "name": "issueDependenciesSummary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blockedBy",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};

(node as any).hash = "8a80b6525c8ed801ba2a1d809f46b887";

export default node;
